export const initialDrawerData = {
  title: "",
  visibility: false,
  groupData: {},
};

export enum DrawerType {
  NEW = "NEW",
  EDIT = "EDIT",
  COPY_BMD = "COPY_BMD",
}
